import React from 'react';
import 'lazysizes';
import DesignCard from '../../DesignCard';

export interface InlinePageDesignRowProps {
    images: string[];
}

export default function InlinePageDesignRow({ images }: InlinePageDesignRowProps) {
    return (
        <div className="inline-page-design-row">
            {images.map((imgUrl, index) => {
                return (
                    <div key={`design-row-${index}`} className="inline-page-design-row__image">
                        <DesignCard
                            variations={['lazyload', 'small', 'low-shadow']}
                            alt=""
                            src={imgUrl}
                        />
                    </div>
                );
            })}
        </div>
    );
}

InlinePageDesignRow.calculateMaxHeightPercentage = function (): number {
    return 0.25;
};
